.content {
  z-index: var(--z-popover);
  min-width: 220px; max-width: 320px; padding: var(--space-1);
  border-radius: var(--radius-md); background: var(--color-surface-raised); box-shadow: var(--shadow-3);
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  animation: in var(--duration-fast) var(--ease-out);
}
.content[data-state="closed"] { animation: out 100ms ease-out forwards; }
.item {
  display: flex; align-items: center; gap: var(--space-3);
  min-height: 34px; padding: 0 var(--space-2-5, 10px); border-radius: var(--radius-xs);
  color: var(--color-text); font-size: var(--text-md); cursor: default; user-select: none; outline: none;
}
.item[data-highlighted] { background: var(--color-surface-hover); }
.item[data-disabled] { color: var(--color-text-muted); }
.danger { color: var(--color-danger); }
.icon { display: grid; place-items: center; width: 18px; color: var(--color-text-secondary); }
.icon svg { width: 18px; height: 18px; }
.text { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.shortcut { color: var(--color-text-muted); font-size: var(--text-xs); font-variant-numeric: tabular-nums; }
.indicator { display: grid; place-items: center; color: var(--color-primary); }
.indicator svg { width: 16px; height: 16px; }
.label { padding: var(--space-2) var(--space-2-5, 10px) var(--space-1); color: var(--color-text-muted); font-size: var(--text-xs); font-weight: var(--weight-medium); }
.separator { height: 1px; margin: var(--space-1) calc(var(--space-1) * -1); background: var(--color-border); }
@keyframes in { from { opacity: 0; transform: scale(0.97); } }
@keyframes out { to { opacity: 0; transform: scale(0.98); } }
